import React, { useEffect, useState } from "react";
import api from 'api';
import { API } from "common/config-api"; // jsconfig.json

const UserAttendanceRow = ({u}) => {
  return (
  <tr>
    <td>{u.userAttendanceType}</td>
    <td>{u.userAttendancePoint}</td>
    <td><code>{u.userAttendanceDate}</code></td>
  </tr>
  );
}


const UserTabAttendance = ({idx}) => {
  
  const apiUrl = `${API.BASE_URL}`;

  const [userAttendanceList, setUserAttendanceList] = useState([]);

  const getUserAttendance = async () => {
    try {
      const response = await api.get(apiUrl + '/user/attendance/list/' + idx);
      const resp = response;
      setUserAttendanceList(resp);
    } catch (error) {
      console.error('출석 정보 조회 실패:', error);
      alert('출석 정보 조회 중 오류가 발생했습니다.');
    }
  };

  useEffect(() => {
    getUserAttendance();
  }, []);

  //console.log("userIdx: ", idx);

  return(
    
    <table className="table table-hover">
    <thead>
      <tr>
        <th colSpan="3">총 출석일 수: {userAttendanceList.length}일</th>
      </tr>        
      <tr>
        <th scope="col">구분</th>
        <th scope="col">포인트</th>
        <th scope="col">날짜</th>
      </tr>
    </thead>
    <tbody>
      {userAttendanceList.length === 0 ? <tr><td colSpan="3">출석 내역이 없습니다.</td></tr> : null}
      {userAttendanceList.length > 0 ? userAttendanceList.map((atts, idx) => ( <UserAttendanceRow key={idx} u={atts} /> )) : null}

    </tbody>
    </table>
    
  );
}

export default UserTabAttendance;




